module.exports = __webpack_public_path__ + "static/img/pic21.1.22693f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic21.1.png
// module id = BGlS
// module chunks = 0